<template>
  <div class="member-container">
    <small-header title="会员风采" moreLink="/member" more></small-header>
    <div class="member-main">
      <swiper v-if="units.length" :options="swiperOption" class="swiper-container">
        <swiper-slide
          v-for="(item, index) in units"
          :key="index">
          <div
            class="member-item"
            @click="toDetail(item)"
          >
            <div
              class="member-item-img"
              :style="{backgroundImage: `url(${$assetsPath + item.imgUrl})`}"
            ></div>
            <div class="member-item-title">{{ item.title }}</div>
            <div class="member-item-desc">{{ item.des }}</div>
          </div>
        </swiper-slide>
        <!-- 分页器 -->
        <div class="swiper-pagination"  slot="pagination"></div>
        <!-- 左右箭头 -->
        <!--      <div class="swiper-button-prev" slot="button-prev"></div>-->
        <!--      <div class="swiper-button-next" slot="button-next"></div>-->
      </swiper>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { getUnitList } from '@/api'

export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      units: [],
      swiperOption:{
        slidesPerView: 3,
        spaceBetween: 30,
        //显示分页
        // pagination: {
        //   el: '.swiper-pagination'
        //   // dynamicBullets: true,
        // },
        //自动轮播
        autoplay: {
          delay: 5000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: false,
        },
        //开启循环模式
        loop: true
      },
    }
  },
  mounted() {
    getUnitList().then(res => {
      this.units = res.rows
    })
  },
  methods: {
    toDetail(obj) {
      this.$setCurArticle(obj)
      this.$router.push('/news-detail')
    }
  }
}
</script>

<style lang="scss" scoped>
.member-container {
  width: 1200px;
  margin: 60px auto 0;
  background: #fff;
  .member-main {
    height: 390px;
    padding: 30px;
    .swiper-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .member-item {
        width: 360px;
        height: 390px;
        background: #F0F7FF;
        cursor: pointer;
        transition: all 300ms;
        user-select: none;
        .member-item-img {
          width: 360px;
          height: 230px;
          background-size: cover;
          background-position: center center;
        }
        .member-item-title {
          margin-top: 20px;
          text-align: center;
          font-size: 20px;
          font-weight: bold;
          color: #074182;
          line-height: 24px;
        }
        .member-item-desc {
          padding: 0 30px;
          margin-top: 20px;
          font-size: 18px;
          color: #484E54;
          line-height: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
      .member-item:hover {
        background: #1279EC;
        .member-item-title,.member-item-desc {
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/Member/index.vue